import { useVariantPayload } from "@/providers/VariantsProvider";
import { useTranslation } from "react-i18next";

export function useDemoButtonText(): string | null {
  const payload = useVariantPayload("demoButtonText");
  const { i18n } = useTranslation();
  const lang = i18n.language;

  if (payload && typeof payload[lang] === "string") {
    return payload[lang];
  }
  return null;
}
